var link = {
  sizes: {
    xSmall: {
      height: '28px',
      padding: '3px 7px'
    },
    small: {
      height: '40px',
      padding: '7px 7px'
    },
    regular: {
      height: '48px',
      padding: '11px 7px'
    },
    large: {
      height: '56px',
      padding: '15px 7px'
    }
  }
};
export default link;